import React, { useEffect, useState } from 'react';
import { auth, db } from '../Firebase';
import { doc, getDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Drawer,
  IconButton,
  useMediaQuery,
  Button
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LogoutIcon from '@mui/icons-material/Logout';
import SofBenLogo from '../Img/SofBenLogo.jpg';
import { useTranslation } from 'react-i18next';
import BarChartIcon from '@mui/icons-material/BarChart';
import MapIcon from '@mui/icons-material/Map';



function Navbar({ onPageChange }) {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [assignedSiteName, setAssignedSiteName] = useState('');



  useEffect(() => {
    const fetchUserInfo = async () => {
      const user = auth.currentUser;
      if (user) {
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setUserRole(data.role);
          setUserName(data.fullName);

          if (data.role === 'worker' && data.assignedSiteId) {
            const siteRef = doc(db, 'ConstructionSites', data.assignedSiteId);
            const siteSnap = await getDoc(siteRef);
            if (siteSnap.exists()) {
              setAssignedSiteName(siteSnap.data().name);
            }
          }
        }
      }
    };

    fetchUserInfo();
  }, []);

  

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };


  const toggleLanguage = () => {
    const nextLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(nextLang);
  };


  const handlePageChange = (page) => {
    onPageChange(page);
    if (isMobile) setDrawerOpen(false); 
  };

  const renderContent = (
    <Box
      sx={{
        width: 250,
        height: '100vh',
        borderRight: '1px solid #ddd',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        p: 2,
      }}
    >

      <Box
        component="img"
        src={SofBenLogo}
        alt="SofBen Logo"
        sx={{ width: 180, mb: 3, mx: 'auto' }}
      />


    <Typography variant="subtitle1" sx={{ color: '#666', textAlign: 'center', mb: 1 }}>
      {userName || t('Utilisateur')} - {userRole === 'admin' ? 'Administrateur' : userRole || t('Rôle')}
    </Typography>

      {userRole === 'worker' && assignedSiteName && (
        <Typography
          variant="body2"
          sx={{
            color: '#777',
            textAlign: 'center',
            fontStyle: 'italic',
            mb: 2
          }}
        >
          {t('Chantier')}: {assignedSiteName}
        </Typography>
      )}


      <Divider sx={{ mb: 2 }} />

      <List>
          {userRole === 'worker' && (
            <>
              <ListItem button onClick={() => handlePageChange('Clocking')} sx={{ mb: 1, borderRadius: 1, py: 1.5, cursor: 'pointer' }}>
                <ListItemIcon sx={{ color: '#c93d3d', minWidth: 40 }}>
                  <AccessTimeIcon fontSize="large" />
                </ListItemIcon>
                <ListItemText
                  primary={t('Page de pointage')}
                  primaryTypographyProps={{ fontSize: '1.1rem', fontWeight: 500, ml: 1 }}
                  sx={{ color: '#333' }}
                />
              </ListItem>

              <ListItem button onClick={() => handlePageChange('Contact')} sx={{ mb: 1, borderRadius: 1, py: 1.5, cursor: 'pointer' }}>
                <ListItemIcon sx={{ color: '#c93d3d', minWidth: 40 }}>
                  <SupportAgentIcon fontSize="large" />
                </ListItemIcon>
                <ListItemText
                  primary={t('Nous contacter')}
                  primaryTypographyProps={{ fontSize: '1.1rem', fontWeight: 500, ml: 1 }}
                  sx={{ color: '#333' }}
                />
              </ListItem>
            </>
          )}

          {userRole === 'admin' && (
            <>
              <ListItem button onClick={() => handlePageChange('AdminClockingReport')} sx={{ mb: 1, borderRadius: 1, py: 1.5, cursor: 'pointer' }}>
                <ListItemIcon sx={{ color: '#c93d3d', minWidth: 40 }}>
                  <AccessTimeIcon fontSize="large" />
                </ListItemIcon>
                <ListItemText
                  primary={t('Rapport de pointage')}
                  primaryTypographyProps={{ fontSize: '1.1rem', fontWeight: 500, ml: 1 }}
                  sx={{ color: '#333' }}
                />
              </ListItem>

              <ListItem
                button
                onClick={() => handlePageChange('AdminSitesMap')}
                sx={{ mb: 1, borderRadius: 1, py: 1.5, cursor: 'pointer' }}
              >
                <ListItemIcon sx={{ color: '#c93d3d', minWidth: 40 }}>
                  <MapIcon fontSize="large" />
                </ListItemIcon>
                <ListItemText
                  primary={t('Carte des chantiers')}
                  primaryTypographyProps={{ fontSize: '1.1rem', fontWeight: 500, ml: 1 }}
                  sx={{ color: '#333' }}
                />
              </ListItem>

              <ListItem button onClick={() => handlePageChange('AdminAnalytics')} sx={{ mb: 1, borderRadius: 1, py: 1.5, cursor: 'pointer' }}>
                <ListItemIcon sx={{ color: '#c93d3d', minWidth: 40 }}>
                  <BarChartIcon fontSize="large" />
                </ListItemIcon>
                <ListItemText
                  primary={t("Page d'analyse")}
                  primaryTypographyProps={{ fontSize: '1.1rem', fontWeight: 500, ml: 1 }}
                  sx={{ color: '#333' }}
                />
              </ListItem>
            </>
          )}


            <ListItem button onClick={() => { handleLogout(); handlePageChange('Accueil'); }} sx={{ mt: 1, borderRadius: 1, py: 1.5, cursor: 'pointer' }}>
              <ListItemIcon sx={{ color: '#c93d3d', minWidth: 40 }}>
                <LogoutIcon fontSize="large" />
              </ListItemIcon>
              <ListItemText
                primary={t('Se déconnecter')}
                primaryTypographyProps={{ fontSize: '1.1rem', fontWeight: 500, ml: 1 }}
                sx={{ color: '#333' }}
              />
            </ListItem>
      </List>

      <Box
        sx={{
          mt: 'auto',
          mb: 4,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          py: 2,
        }}
      >
        <Box
          sx={{
            width: 100,
            height: 40,
            borderRadius: 20,
            backgroundColor: '#eee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: i18n.language === 'fr' ? 'flex-start' : 'flex-end',
            px: 1,
            cursor: 'pointer',
            position: 'relative',
            transition: 'all 0.3s ease-in-out',
          }}
          onClick={() => {
            const nextLang = i18n.language === 'fr' ? 'en' : 'fr';
            i18n.changeLanguage(nextLang);
          }}
        >
          {/* Labels */}
          {i18n.language !== 'fr' && (
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                left: 10,
                fontWeight: 'bold',
                color: '#555',
              }}
            >
              FR
            </Typography>
          )}

          {i18n.language !== 'en' && (
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                right: 10,
                fontWeight: 'bold',
                color: '#555',
              }}
            >
              EN
            </Typography>
          )}


          {/* Flag */}
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              backgroundImage: `url(${
                i18n.language === 'fr'
                  ? 'https://flagcdn.com/fr.svg'
                  : 'https://flagcdn.com/gb.svg'
              })`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transition: '0.3s',
            }}
          />
        </Box>
      </Box>

    </Box>
  );

  const renderMobileTopBar = (
    <Box
      sx={{
        width: '100%',
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        backgroundColor: '#ffffff',
        boxShadow: 1,
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1200,
      }}
    >
      <IconButton onClick={() => setDrawerOpen(true)}>
        <MenuIcon />
      </IconButton>

      <Box
        component="img"
        src={SofBenLogo}
        alt="SofBen Logo"
        sx={{ height: 60, objectFit: 'contain' }}
      />

      <Box width="40px" /> {/* placeholder for spacing */}
    </Box>
  );

  return (
    <>
      {isMobile && renderMobileTopBar}

      {isMobile ? (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          ModalProps={{ keepMounted: true }}
        >
          {renderContent}
        </Drawer>
      ) : (
        renderContent
      )}
    </>
  );
}

export default Navbar;